const startOfLocalDay = (date: Date) => {
  const normalized = new Date(date.getTime());
  normalized.setHours(0, 0, 0, 0);
  return normalized;
};

/**
 * Labels a conversation by the calendar day it was last active on. Both sides
 * are normalized to midnight first, so an evening conversation is still called
 * "Yesterday" the next morning, and rounding absorbs a daylight-saving shift.
 */
export const relativeDay = (isoTimestamp: string, now: Date = new Date()): string => {
  const updatedAt = new Date(isoTimestamp);
  if (Number.isNaN(updatedAt.getTime())) return "";

  const elapsed = startOfLocalDay(now).getTime() - startOfLocalDay(updatedAt).getTime();
  const dayDifference = Math.round(elapsed / 86_400_000);

  if (dayDifference <= 0) return "Today";
  if (dayDifference === 1) return "Yesterday";
  if (dayDifference < 7) return `${String(dayDifference)} days ago`;
  return updatedAt.toLocaleDateString();
};
